import { render, staticRenderFns } from "./satisfy-notice-component.vue?vue&type=template&id=14ed4a66&scoped=true&"
import script from "./satisfy-notice-component.vue?vue&type=script&lang=ts&"
export * from "./satisfy-notice-component.vue?vue&type=script&lang=ts&"
import style0 from "./satisfy-notice-component.vue?vue&type=style&index=0&id=14ed4a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed4a66",
  null
  
)

export default component.exports